import React, { Fragment, useState } from "react";

import DayPlanForm from "./components/DayPlanForm";
import { DayPlan } from "../../../../types/DayPlan";
import { getFirebaseKey } from "../../../../database/utils/getFirebaseKey";
import Dialog from "../../../common/Dialog";
import FullScreenDialog from "../../../common/FullScreenDialog";
import ActionButton from "../../../common/ActionButton";
import Table from "../../../common/table";
import removeDayPlan from "../../../../database/dayPlan/removeDayPlan";

const tabConfig = [
  {
    columnTitle: "Position",
    dataField: ["position"],
  },
  {
    columnTitle: "Title",
    dataField: ["title"],
  },
  {
    columnTitle: "Description",
    dataField: ["description"],
  },
];

type Props = {
  setFieldValue: any;
  dayPlans: DayPlan[];
  planID: string;
  communityId: string;
  authorID: string;
  planTitle?: string;
  planDescription?: string;
  authorName?: string;
  authorDescription?: string;
};

const EMPTY_DAY_PLAN: DayPlan = {
  id: "",
  createdAt: "",
  description: "",
  position: 0,
  planID: "",
  steps: [],
  title: "",
  communityId: "",
  isActive: false,
  authorID: "",
};

const DayPlanTable = ({
  dayPlans,
  setFieldValue,
  planID,
  authorID,
  communityId,
  planTitle,
  planDescription,
  authorName,
  authorDescription,
}: Props) => {
  const [isDayPlanFormOpen, setisDayPlanFormOpen] = useState(false);
  const [mode, setMode] = useState("");
  const [isRemoveDialogOpen, setIsRemoveDialogOpen] = useState(false);
  const [DayPlanSelected, setDayPlanSelected] = useState<DayPlan>({
    ...EMPTY_DAY_PLAN,
  });
  const [currentPage, setCurrentPage] = useState(0);

  const onToggleDayPlanForm = (): void => {
    const willOpen = !isDayPlanFormOpen;

    if (willOpen) {
      setMode("create");
      setDayPlanSelected({ ...EMPTY_DAY_PLAN });
    }
    setisDayPlanFormOpen(willOpen);
  };

  const onToggleRemoveDialog = (): void => {
    setIsRemoveDialogOpen(!isRemoveDialogOpen);
  };

  const onRemoveIconClicked = (saleSelectedVal: DayPlan): void => {
    setIsRemoveDialogOpen(true);
    setDayPlanSelected(saleSelectedVal);
  };

  const onEditIconClicked = (dayPlanSelected: DayPlan): void => {
    setMode("edit");
    setisDayPlanFormOpen(true);

    console.log("Edit Day Plan", dayPlanSelected);

    setDayPlanSelected({
      ...dayPlanSelected,
      steps: [...(dayPlanSelected?.steps || [])],
    });
  };

  const onTablePageChange = (newPage: number): void => {
    setCurrentPage(newPage);
  };
  const onCreateDayPlan = (dayPlan: DayPlan): void => {
    const databaseKey = getFirebaseKey();
    const newDayPlans = [
      ...dayPlans,
      { ...dayPlan, id: databaseKey, steps: [...(dayPlan?.steps || [])] },
    ];
    setFieldValue("dayPlans", newDayPlans);
    onToggleDayPlanForm();

    /*editProductSubsection({
      DayPlan: subsection,
      storeId,
      productId,
    });*/
  };

  const onEditDayPlan = (dayPlan: DayPlan): void => {
    const newDayPlans = dayPlans.map((currentPlan) =>
      currentPlan.id === DayPlanSelected.id
        ? { ...dayPlan, id: DayPlanSelected.id, steps: [...(dayPlan?.steps || [])] }
        : currentPlan
    );

    setFieldValue("dayPlans", newDayPlans);
    onToggleDayPlanForm();
  };

  const onRemoveDayPlan = (): void => {
    if (!dayPlans || !DayPlanSelected) return;
    console.log('DayPlanSelected', DayPlanSelected)
    const newDayPlans = dayPlans.filter(
      (DayPlan) => DayPlan.id !== DayPlanSelected.id
    );

    setFieldValue("dayPlans", newDayPlans);
    removeDayPlan({
      dayPlanId: DayPlanSelected.id,
    });
  };

  const renderDeleteDialog = (): any => {
    return (
      <Dialog
        description="Si realizas esta acción, los Day Plans serán eliminados, y no habrá manera de recuperarlos."
        title="¿Estás seguro de que deseas eliminar este Day Plan?"
        negativeAction={onToggleRemoveDialog}
        onCloseDialog={onToggleRemoveDialog}
        positiveAction={onRemoveDayPlan}
        isOpen={isRemoveDialogOpen}
        positiveText="SÍ"
        negativeText="NO"
      />
    );
  };
  const renderDayPlanForm = (): any => {
    return (
      <FullScreenDialog
        onClose={onToggleDayPlanForm}
        isOpen={isDayPlanFormOpen}
        title={"Day Plan"}
      >
        <DayPlanForm
          onToggleFullScreenDialog={onToggleDayPlanForm}
          onRemoveItem={onRemoveDayPlan}
          onCreateItem={onCreateDayPlan}
          onEditItem={onEditDayPlan}
          item={DayPlanSelected}
          planID={planID}
          authorID={authorID}
          communityId={communityId}
          mode={mode}
          planTitle={planTitle}
          planDescription={planDescription}
          authorName={authorName}
          authorDescription={authorDescription}
        />
      </FullScreenDialog>
    );
  };
  const renderTable = (): Object => {
    return (
      <div>
        <ActionButton
          action={onToggleDayPlanForm}
          title={"New Day Plan"}
          withIcon
          disabled={false}
        />
        <Table
          canBeEdited
          onEditIconClicked={onEditIconClicked}
          onRemoveIconClicked={onRemoveIconClicked}
          updatePageIndex={onTablePageChange}
          currentPage={currentPage}
          tabConfig={tabConfig}
          dataset={dayPlans}
          canBeRemoved
        />
      </div>
    );
  };

  return (
    <Fragment>
      {renderDeleteDialog()}
      {renderTable()}
      {renderDayPlanForm()}
    </Fragment>
  );
};

export default DayPlanTable;
